let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("54Nqe")).then(() => parcelRequire('040p3'));